import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  background-color: #fff;
  top: 1.9em;
  left: 3rem;
  width: 8.3rem;
  height: fit-content;
  border: 1px solid #ebebeb;
  border-top-left-radius: 0.92rem;
  border-bottom-left-radius: 0.92rem;
  border-bottom-right-radius: 0.92rem;
  box-shadow: 0px 8px 16px 0px #0000001A;
  z-index: 1;
`

export const OptionDiv = styled.div`
  display: flex;
  width: 8.2rem;
  height: 2.4rem;
  padding-left: 0.92rem;
  cursor: pointer;

  :hover {
    background-color: #F4F4F4;
  }
`

export const OptionImg = styled.img`
  width: 0.92rem;
`

export const OptionText = styled.p`
  margin-left: 0.92rem;
  font-size: clamp(0.65rem, calc(0.65rem + 0.1vw), 1.4rem);
  font-family: 'Inter', sans-serif;
`